import { api } from "../../http";

async function DeleteDataItem(id) {
  try {
    
    const data = await api.delete(`/items/${id}`);
    return data;


  } catch (e) {
    console.log(e);
  }
}

export { DeleteDataItem };
